import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Customer } from 'src/app/api/customer/customer';
import { CustomerApiService } from 'src/app/api/customer/customerApiService';

@Component({
    selector: 'customer-details',
    templateUrl: './customer-details.component.html',
    styleUrls: ['./customer-details.component.css'],
    host: {'class': 'page-container'},
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomerDetailsComponent implements OnInit {
  customer: Customer | null = null;
  loading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private customerApiService: CustomerApiService
  ) { }

  ngOnInit(): void {
      const id = this.route.snapshot.paramMap.get('id');
      if (id == null)
        return;

    this.loading = true;
    this.customerApiService.getCustomer(id)
      .subscribe(x => {
        this.customer = x;
        this.loading = false;
      });
  }

  back(): void {
    this.location.back()
  }
}
